import { Component, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GetSimulatedPotentialSellersInput } from '../../../../shared/models/lead/getSimulatedPotentialSellers.input';
import { NewLeadInput } from '../../../../shared/models/lead/newLead.input';
import { EventService } from '../../../../shared/services/event/event.service';
import { LeadService } from '../../../../shared/services/lead/lead.service';
import { StylesProvider } from '../../../../shared/services/utils/styles.provider';
import { ToastService } from '../../../../shared/services/utils/toast.service';
import { TranslatorService } from '../../../../shared/services/utils/translator.service';
import { LeadsComunicationService } from '../../../leads/leads-comunication.service';
import { ModalsHandlerService } from '../../modals.handler.service';
import { TemplateLeadFormComponent } from '../template-lead-form-component';

@Component({
  selector: 'ngx-assignment-rules-simulator',
  templateUrl: '../template-lead-form.html',
})
export class AssignmentRulesSimulatorComponent extends TemplateLeadFormComponent {

  newLeadInput: NewLeadInput = new NewLeadInput();
  newModal: boolean;
  editModal: boolean;
  simulateModal: boolean;

  @ViewChild('dropDownChannel', { static: false }) channel: TemplateRef<any>;

  constructor(
    protected leadComunicationService: LeadsComunicationService,
    protected modalsHandler: ModalsHandlerService,
    protected modalService: NgbModal,
    protected toasterService: ToastService,
    protected styleProvider: StylesProvider,
    protected formBuilder: FormBuilder,
    protected readonly leadService: LeadService,
    protected readonly translateService: TranslatorService,
    protected eventService: EventService,
  ) {
    super(
      leadComunicationService,
      leadService,
      modalsHandler,
      modalService,
      toasterService,
      formBuilder,
      styleProvider,
      eventService
    );
    this.modalEmitter = this.modalsHandler.simulateLeadModal;
    this.newModal = false;
    this.editModal = false;
    this.simulateModal = true;
    this.zipCode = '';
  }

  launchQuery(): void {
    const getSimulatedPotentialSellersInput = new GetSimulatedPotentialSellersInput(this.lead);
    this.leadService.getSimulatedPotentialSellers(getSimulatedPotentialSellersInput).subscribe(data => {
      this.modalsHandler.openSimulatedPotentialSellersModal(data);
    });
    this.zipCode = '';
    this.leadForm.patchValue(this.lead);

  }

  getLead(): void {
    this.zipCode = '';

    this.lead.contactName = this.translateService.trans('modals.simulate.lead.title');
    this.lead.descriptionModel = this.translateService.trans('modals.simulate.lead.model');
    this.lead.contactPhone = this.translateService.trans('modals.simulate.lead.phone');
    this.lead.contactEmail = this.translateService.trans('modals.simulate.lead.email');
    this.leadForm.patchValue(this.lead);
  }

  closeModal() {
    return;
  }

}
